import React from 'react';
import { FileOutlined } from '@ant-design/icons';
import AppIconGroup from '../../components/app-icon-group';
import SwitchShop from '../shop/switch-shop';
import PageList from './page-list';

export default () => {
    return (
        <div className="space-y-4">
            <SwitchShop />
            {window.__baseInfo.versionId !== 1 && (
                <AppIconGroup 
                    items={[
                        {
                            id: 1,
                            href: '/mall/page/create',
                            title: '创建页面',
                            icon: <FileOutlined />,
                            color: 'from-blue-500 to-blue-600'
                        }
                    ]}
                />
            )}
            <div>
                <h2 className="admin-page-title">商城页面</h2>
                <PageList />
            </div>
        </div>
    );
};